import clsx from 'clsx';
import { FC } from 'react';
import { isMobile } from '../../utils/common';

const Skeleton: FC = () => {
    const isMob = isMobile();

    return (
        <div className='bg-white pb-5'>
            <div className={clsx('flex flex-col pt-30 pb-5', !isMob && 'max-w-desktop-max mx-auto px-30')}>
                <h4
                    className={clsx(
                        'animate-pulse h4 w-fit min-h-40 font-medium text-charcoal-80 bg-charcoal-80 rounded-5',
                        isMob && 'mx-20',
                    )}
                >
                    Hi Ekagra, need help with your recent booking?
                </h4>
                <div className='relative w-full my-auto mx-0'>
                    <div className='flex overflow-hidden gap-20'>
                        {Array.from({ length: 4 }).map((_, i) => (
                            <div
                                // eslint-disable-next-line react/no-array-index-key
                                key={i}
                                className={clsx(
                                    'animate-pulse w-full rounded-xl p-10 bg-charcoal-80',
                                    isMob ? 'shrink-0 max-w-[85%] my-15 first-of-type:ml-20' : 'my-20',
                                )}
                            >
                                <div className='flex gap-10 overflow-hidden'>
                                    <div className='w-80 h-100 rounded-10' />
                                    <div className='flex flex-col justify-between overflow-hidden' />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Skeleton;
